<template>
  <div>
    <a-form-model class="basic" :model="form" :rules="rules" ref="baseForm">
      <a-collapse
        :bordered="true"
        expand-icon-position="right"
        :activeKey="['1', '2', '3', '4']"
        class="detail-collapse"
      >
        <!-- ===================== 权证基本信息 ===================== -->
        <a-collapse-panel key="1">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                权证基本信息
              </div>
            </a-space>
          </template>
          <BasicInfo :form="form" :isEditable="isEditable"></BasicInfo>
        </a-collapse-panel>

        <!-- ===================== 权利人信息 ===================== -->
        <a-collapse-panel key="2">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                权利人信息
              </div>
            </a-space>
          </template>
          <ObligeeInfo
            ref="obligeeInfo"
            :form="form"
            :isEditable="isEditable"
          ></ObligeeInfo>
        </a-collapse-panel>

        <!-- ===================== 申请人信息 ===================== -->
        <a-collapse-panel key="3">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                申请人信息
              </div>
            </a-space>
          </template>
          <ApplyInfo :form="form" :isEditable="isEditable"></ApplyInfo>
        </a-collapse-panel>

        <!-- ===================== 上传附件 ===================== -->
        <a-collapse-panel key="4">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                上传附件
              </div>
            </a-space>
          </template>
          <Attachment :form="form" :isEditable="isEditable"></Attachment>
        </a-collapse-panel>
      </a-collapse>
    </a-form-model>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import BasicInfo from "./basicInfo/BasicInfo";
import ObligeeInfo from "./obligeeInfo/ObligeeInfo";
import ApplyInfo from "./applyInfo/ApplyInfo";
import Attachment from "./attachment/Attachment";
import { getObligeeDetail } from "@/api/company/Company.js";
import { applyPersonalInfo } from "@/api/user/personalCenter/PersonalCenter.js";
import { scrollToTop } from "@/utils/util";
import {
  saveWarrant,
  submitWarrant,
  getWarrantDetail,
} from "@/api/property/Property.js";
export default {
  props: {
    isEditable: {
      type: Boolean,
      default: () => true,
    },
    webId: {
      type: String,
      default: () => undefined,
    },
  },
  components: {
    BasicInfo,
    ObligeeInfo,
    ApplyInfo,
    Attachment,
  },
  data() {
    return {
      form: {
        //父层传值
        otype: 0,
        webId: undefined,
        certificateNumber: undefined,
        propertyType: undefined,
        useRightsFileName: undefined,
        certificateArea: undefined,
        label: undefined,
        rightsCertificateFileName: undefined,
        //前端展示地理位置信息
        certificateAddressCode: undefined,
        certificateAddress: undefined,
        consistentWithCertificate: undefined,
        //前端展示地理位置信息
        physicalAddressCode: undefined,
        physicalAddress: undefined,
        district: undefined,
        isCoverBlock: undefined,
        block: [],
        assetUse: undefined,
        //权利人信息
        allowAuthorization: undefined,
        obligeeType: undefined,
        obligeeName: undefined,
        legalRepresentative: undefined,
        socialCreditCode: undefined,
        obligeeStateOwnedEnterprises: undefined,
        obligeeEconomicType: undefined,
        obligeeAffiliatedGroup: undefined,
        obligeeRegulatoryAuthority: undefined,
        //申请人信息
        applicantName: undefined,
        applicantPhone: undefined,
        applyingBusiness: undefined,
        applyingBusinessCreditCode: undefined,
        stateOwnedEnterprises: undefined,
        applyingEconomicType: undefined,
        obligeeEnterpriseName: undefined,
        applyingRegulatoryAuthority: undefined,
        //上传附件
        rightAttachement: [
          {
            id: 1,
            type: "产权情况证明文件",
            files: [],
            uploadType: 101,
          },
          {
            id: 2,
            type: "其他材料",
            files: [],
            uploadType: 102,
          },
        ],
        //春节测试
        propertyType: 2,
        district: 1,
        certificateAddressCode: ["310000", "310100", "310109"],
        //春节测试
      },
      rules: {
        certificateNumber: [
          { required: true, message: "请输入权证编号", trigger: "submit" },
        ],
        propertyType: [
          { required: true, message: "请选择权证类型", trigger: "submit" },
        ],
        useRightsFileName: [
          {
            required: true,
            message: "请输入使用权证明文件名",
            trigger: "submit",
          },
        ],
        rightsCertificateFileName: [
          {
            required: true,
            message: "请输入权利证明文件名称",
            trigger: "submit",
          },
        ],
        label: [{ required: true, message: "请选择标签", trigger: "submit" }],
        certificateArea: [
          // 只在提交时必填
          { required: true, message: "请输入权证面积", trigger: "submit" },

          // blur 时：允许为空；不为空则校验数字与范围
          {
            validator: (rule, value, callback) => {
              // 1) 为空直接通过（保存时允许为空；提交的必填交给上面 required）
              if (value === undefined || value === null || value === "") {
                callback();
                return;
              }

              // 2) 非数字
              // 注意：value 可能是字符串，所以用 Number 转一下更稳
              const num = Number(value);
              if (Number.isNaN(num)) {
                callback(new Error("权证面积必须为数字"));
                return;
              }

              // 3) 范围
              if (num < 0) {
                callback(new Error("权证面积必须大于等于0"));
                return;
              }

              callback();
            },
            trigger: "blur",
          },
        ],
        certificateAddressCode: [
          { required: true, message: "请输入权证地址", trigger: "submit" },
        ],
        certificateAddress: [
          {
            required: true,
            message: "请输入权证地址详细地点",
            trigger: "submit",
          },
        ],
        consistentWithCertificate: [
          {
            required: true,
            message: "请选择权证实际地址类型",
            trigger: "submit",
          },
        ],
        physicalAddressCode: [
          { required: true, message: "请输入实际地址", trigger: "submit" },
        ],
        physicalAddress: [
          {
            required: true,
            message: "请输入实际地址详细地点",
            trigger: "submit",
          },
        ],
        district: [
          { required: true, message: "请选择所属地段", trigger: "submit" },
        ],
        isCoverBlock: [
          { required: true, message: "请选择是否涉及板块", trigger: "submit" },
        ],
        block: [
          { required: true, message: "请选择所属板块", trigger: "submit" },
        ],
        assetUse: [
          { required: true, message: "请填写权证用途", trigger: "submit" },
        ],
        obligeeType: [
          { required: true, message: "请选择权利人类型", trigger: "submit" },
        ],
        allowAuthorization: [
          { required: true, message: "请选择是否授权登记", trigger: "submit" },
        ],
        obligeeName: [
          { required: true, message: "请输入权利人名称", trigger: "submit" },
        ],
        legalRepresentative: [
          {
            required: true,
            message: "请输入权利人法定代表人",
            trigger: "submit",
          },
        ],
        socialCreditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "submit",
          },
        ],
        obligeeEconomicType: [
          {
            required: true,
            message: "请选择权利人经济类型",
            trigger: "submit",
          },
        ],
        obligeeStateOwnedEnterprises: [
          { required: true, message: "请选择是否国资", trigger: "submit" },
        ],
        obligeeAffiliatedGroup: [
          {
            required: true,
            message: "请输入权利人所属集团",
            trigger: "submit",
          },
        ],
        obligeeRegulatoryAuthority: [
          {
            required: true,
            message: "请输入权利人监管部门",
            trigger: "submit",
          },
        ],
        applicantName: [
          { required: true, message: "请输入申请人名称", trigger: "submit" },
        ],
        applicantPhone: [
          { required: true, message: "请输入申请人电话", trigger: "submit" },
        ],
        applyingBusiness: [
          { required: true, message: "请输入申请企业名称", trigger: "submit" },
        ],
        applyingBusinessCreditCode: [
          {
            required: true,
            message: "请输入申请企业统一社会信用代码",
            trigger: "submit",
          },
        ],
        stateOwnedEnterprises: [
          { required: true, message: "请选择是否国资", trigger: "submit" },
        ],
        applyingEconomicType: [
          {
            required: true,
            message: "请选择申请企业经济类型",
            trigger: "submit",
          },
        ],
        obligeeEnterpriseName: [
          {
            required: true,
            message: "请输入申请人所属集团",
            trigger: "submit",
          },
        ],
        applyingRegulatoryAuthority: [
          {
            required: true,
            message: "请输入申请人监管部门",
            trigger: "submit",
          },
        ],
      },
    };
  },
  mounted() {
    //1.详情查询出所有的历史数据+所有树结构 2.编辑和更新申请人信息就是最新数据
    //判断是否有webId,有需要调用，form.otpye = 1改为修改 form.webId = webId，最好加个loading
    if (this.webId && this.webId.trim() !== "") {
      getWarrantDetail({ webId: this.webId })
        .then((res) => {
          if (res && res.code === "200") {
            const baseInfo = res.data.baseInfo;
            this.form.otype = 1;
            this.form.webId = baseInfo.webId;
            this.form.certificateNumber = baseInfo.certificateNumber;
            this.form.propertyType = baseInfo.propertyType;
            this.form.useRightsFileName = baseInfo.useRightsFileName;
            this.form.certificateArea = baseInfo.certificateArea;
            this.form.label = baseInfo.label;
            this.form.rightsCertificateFileName =
              baseInfo.rightsCertificateFileName;
            //前端展示地理位置信息
            this.form.certificateAddressCode = [
              baseInfo.certificateProvinceCode,
              baseInfo.certificateCityCode,
              baseInfo.certificateRegionCode,
            ].filter(Boolean);
            this.form.certificateAddress = baseInfo.certificateAddress;
            this.form.consistentWithCertificate =
              baseInfo.consistentWithCertificate;
            //前端展示地理位置信息
            this.form.physicalAddressCode = [
              baseInfo.physicalProvinceCode,
              baseInfo.physicalCityCode,
              baseInfo.physicalRegionCode,
            ].filter(Boolean);
            this.form.physicalAddress = baseInfo.physicalAddress;
            this.form.district = baseInfo.district;
            this.form.isCoverBlock = baseInfo.isCoverBlock;
            this.form.block = baseInfo.block;
            this.form.assetUse = baseInfo.assetUse;
            //权利人信息
            this.form.allowAuthorization = baseInfo.allowAuthorization;
            this.form.obligeeType = baseInfo.obligeeType;
            this.form.obligeeName = baseInfo.obligeeName;
            this.form.legalRepresentative = baseInfo.legalRepresentative;
            this.form.socialCreditCode = baseInfo.socialCreditCode;
            this.form.obligeeStateOwnedEnterprises =
              baseInfo.obligeeStateOwnedEnterprises;
            this.form.obligeeEconomicType = baseInfo.obligeeEconomicType;
            this.form.obligeeAffiliatedGroup = {
              label: baseInfo.obligeeAffiliatedGroup,
              value: baseInfo.obligeeAffiliatedGroupCreditCode,
            };
            this.form.obligeeRegulatoryAuthority = {
              label: baseInfo.obligeeRegulatoryAuthority,
              value: baseInfo.obligeeRegulatoryAuthorityCreditCode,
            };
            //申请人信息 如果是不可编辑的说明是详情，需要赋值历史值
            if (!this.isEditable) {
              this.form.applicantName = baseInfo.applicantName;
              this.form.applicantPhone = baseInfo.applicantPhone;
              this.form.applyingBusiness = baseInfo.applyingBusiness;
              this.form.applyingBusinessCreditCode =
                baseInfo.applyingBusinessCreditCode;
              this.form.stateOwnedEnterprises = baseInfo.stateOwnedEnterprises;
              this.form.applyingEconomicType = baseInfo.applyingEconomicType;
              this.form.obligeeEnterpriseName = {
                label: baseInfo.obligeeEnterpriseName,
                value: baseInfo.obligeeEnterpriseCreditCode,
              };
              this.form.applyingRegulatoryAuthority = {
                label: baseInfo.applyingRegulatoryAuthority,
                value: baseInfo.applyingRegulatoryAuthorityCreditCode,
              };
            }
            //产权情况证明文件
            this.form.rightAttachement.find(
              (item) => item.uploadType === 101
            ).files = res.data.propertyRightsProof.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.propertyRightsProofUrl,
              };
            });
            //其他材料
            this.form.rightAttachement.find(
              (item) => item.uploadType === 102
            ).files = res.data.otherMaterials.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.otherMaterialsUrl,
              };
            });
          } else {
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        });
    }

    //如果是可编辑的 说明 一定是编辑或者更新，申请人信息同步最新值
    if (this.isEditable) {
      applyPersonalInfo()
        .then((res) => {
          if (res && res.code === "200") {
            const result = res.data;
            this.form.applicantName = result.certName;
            this.form.applicantPhone = result.mobile;
          } else {
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        });
      //申请人企业信息同不做第三方授权的权利人，复用一下
      getObligeeDetail()
        .then((res) => {
          if (res && res.code === "200") {
            const result = res.data;
            this.form.applyingBusiness = result.obligeeName;
            this.form.applyingBusinessCreditCode = result.socialCreditCode;
            this.form.stateOwnedEnterprises =
              result.obligeeStateOwnedEnterprises;
            this.form.applyingEconomicType = result.obligeeEconomicType;
            this.form.obligeeEnterpriseName = {
              label: result.obligeeAffiliatedGroup,
              value: result.obligeeAffiliatedGroupCreditCode,
            };
            this.form.applyingRegulatoryAuthority = {
              label: result.obligeeRegulatoryAuthority,
              value: result.obligeeRegulatoryAuthorityCreditCode,
            };
          } else {
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        });
    }
  },

  watch: {
    "form.allowAuthorization": {
      immediate: true,
      handler(val) {
        // todo开始
        // ⭐核心判断加入页面模式mode,如果是详情则跳过，直接用调用数据
        // if (this.mode === "view") return;
        // todo结束
        //不授权登记
        if (val === 0) {
          // 清除校验错误
          this.$nextTick(() => {
            this.$refs.baseForm?.clearValidate([
              "obligeeType",
              "obligeeName",
              "legalRepresentative",
              "socialCreditCode",
              "obligeeStateOwnedEnterprises",
              "obligeeEconomicType",
              "obligeeRegulatoryAuthority",
              "obligeeAffiliatedGroup",
            ]);
          });
          //变更为默认权利人信息
          this.$refs.obligeeInfo.obligeeTypeDictionaries(true);
          this.$refs.obligeeInfo.obligeeEconomicTypeDictionaries(true);
          this.form.obligeeType = "1";
          getObligeeDetail()
            .then((res) => {
              if (res && res.code === "200") {
                const result = res.data;
                this.form.obligeeName = result.obligeeName;
                this.form.legalRepresentative = result.legalRepresentative;
                this.form.socialCreditCode = result.socialCreditCode;
                this.form.obligeeStateOwnedEnterprises =
                  result.obligeeStateOwnedEnterprises;
                this.form.obligeeEconomicType = result.obligeeEconomicType;
                this.form.obligeeAffiliatedGroup = {
                  label: result.obligeeAffiliatedGroup,
                  value: result.obligeeAffiliatedGroupCreditCode,
                };
                this.form.obligeeRegulatoryAuthority = {
                  label: result.obligeeRegulatoryAuthority,
                  value: result.obligeeRegulatoryAuthorityCreditCode,
                };
              } else {
              }
            })
            .catch((err) => {
              console.error("接口调用异常：", err);
            });
        } else {
        }
      },
    },
  },
  methods: {
    /** 保存（不强校验） */
    handleSave() {
      // 将权证地址映射成
      const certificateAddressCode = this.form.certificateAddressCode || [];
      this.form.certificateProvinceCode =
        certificateAddressCode[0] || undefined;
      this.form.certificateCityCode = certificateAddressCode[1] || undefined;
      this.form.certificateRegionCode = certificateAddressCode[2] || undefined;

      // 将实际地址映射成
      const physicalAddressCode = this.form.physicalAddressCode || [];
      this.form.physicalProvinceCode = physicalAddressCode[0] || undefined;
      this.form.physicalCityCode = physicalAddressCode[1] || undefined;
      this.form.physicalRegionCode = physicalAddressCode[2] || undefined;

      // 产权情况证明文件（101）
      const propertyRightsProofList = this.form.rightAttachement
        .filter((item) => item.uploadType === 101)
        .flatMap((item) => item.files || [])
        .filter((file) => file.status === "done")
        .map((file) => ({
          name: file.name,
          url: file.url,
        }));

      // 其他材料（102）
      const otherMaterialList = this.form.rightAttachement
        .filter((item) => item.uploadType === 102)
        .flatMap((item) => item.files || [])
        .filter((file) => file.status === "done")
        .map((file) => ({
          name: file.name,
          url: file.url,
        }));

      saveWarrant({
        ...this.form,
        //附件文件
        propertyRightsProofList,
        otherMaterialList,
        //树结构重构下参数
        obligeeAffiliatedGroup: this.form.obligeeAffiliatedGroup?.label || "",
        obligeeAffiliatedGroupCreditCode:
          this.form.obligeeAffiliatedGroup?.value || "",
        obligeeRegulatoryAuthority:
          this.form.obligeeRegulatoryAuthority?.label || "",
        obligeeRegulatoryAuthorityCreditCode:
          this.form.obligeeRegulatoryAuthority?.value || "",
        obligeeEnterpriseName: this.form.obligeeEnterpriseName?.label || "",
        obligeeEnterpriseCreditCode:
          this.form.obligeeEnterpriseName?.value || "",
        applyingRegulatoryAuthority:
          this.form.applyingRegulatoryAuthority?.label || "",
        applyingRegulatoryAuthorityCreditCode:
          this.form.applyingRegulatoryAuthority?.value || "",
      })
        .then((res) => {
          if (res && res.code === "200") {
            const result = res.data;
            this.form.otype = 1;
            this.form.webId = result;
          }
          setTimeout(() => {
            this.$notification.success({
              message: `保存成功`,
              description: `权证信息`,
            });
          }, 500);
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        });
    },

    /** 提交（强校验） */
    handleSubmit() {
      this.$refs.baseForm.validate((valid) => {
        if (!valid) {
          this.$notification.warning({
            message: "注意",
            description: "请先完善权证信息",
            duration: 4,
          });
          return;
        }

        // 1. 校验“产权情况证明文件”是否上传
        const propertyCert = this.form.rightAttachement.find(
          (item) => item.uploadType === 101
        );

        if (!propertyCert || this.getUploadedFiles(propertyCert).length === 0) {
          this.$notification.warning({
            message: "注意",
            description: "请上传产权情况证明文件",
            duration: 4,
          });
          return;
        }

        // 将权证地址映射成
        const certificateAddressCode = this.form.certificateAddressCode || [];
        this.form.certificateProvinceCode =
          certificateAddressCode[0] || undefined;
        this.form.certificateCityCode = certificateAddressCode[1] || undefined;
        this.form.certificateRegionCode =
          certificateAddressCode[2] || undefined;

        // 将实际地址映射成
        const physicalAddressCode = this.form.physicalAddressCode || [];
        this.form.physicalProvinceCode = physicalAddressCode[0] || undefined;
        this.form.physicalCityCode = physicalAddressCode[1] || undefined;
        this.form.physicalRegionCode = physicalAddressCode[2] || undefined;

        // 产权情况证明文件（101）
        const propertyRightsProofList = this.form.rightAttachement
          .filter((item) => item.uploadType === 101)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 其他材料（102）
        const otherMaterialList = this.form.rightAttachement
          .filter((item) => item.uploadType === 102)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        submitWarrant({
          ...this.form,
          //附件文件
          propertyRightsProofList,
          otherMaterialList,
          //树结构重构下参数
          obligeeAffiliatedGroup: this.form.obligeeAffiliatedGroup.label,
          obligeeAffiliatedGroupCreditCode:
            this.form.obligeeAffiliatedGroup.value,
          obligeeRegulatoryAuthority:
            this.form.obligeeRegulatoryAuthority.label,
          obligeeRegulatoryAuthorityCreditCode:
            this.form.obligeeRegulatoryAuthority.value,
          obligeeEnterpriseName: this.form.obligeeEnterpriseName.label,
          obligeeEnterpriseCreditCode: this.form.obligeeEnterpriseName.value,
          applyingRegulatoryAuthority:
            this.form.applyingRegulatoryAuthority.label,
          applyingRegulatoryAuthorityCreditCode:
            this.form.applyingRegulatoryAuthority.value,
        })
          .then((res) => {
            if (res && res.code === "200") {
              setTimeout(() => {
                this.$notification.success({
                  message: `提交成功`,
                  description: `请等待审核结果`,
                });
                this.$emit("back");
                //滚动到最上方
                this.$nextTick(() => {
                  scrollToTop(this, 80);
                });
              }, 200);
            }
          })
          .catch((err) => {
            console.error("接口调用异常：", err);
          });
      });
    },

    //获取上传文件信息
    getUploadedFiles(record) {
      if (!record.files || !record.files.length) return [];
      return record.files.filter((f) => f.status === "done");
    },
  },
};
</script>

<style scoped>
.detail-collapse {
  background: #fff;
}
.detail-collapse /deep/ .ant-collapse-header {
  font-size: 15px;
  font-weight: bold;
}
.detail-collapse /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}

::v-deep .detail-collapse .ant-form-item {
  margin-bottom: 4px !important; /* 自己改 */
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
